import { isValidInternationalPhone, toInternationalPhone } from '@util/internationalPhone'
import * as yup from 'yup'
import { dobSchema, emailSchema, firstNameSchema, genderSchema, lastNameShema, otherNameSchema } from './userSchema'

export const addPatientSchema = yup.object({
  charge_registration_fee: yup.boolean().default(true),
  date_of_birth: dobSchema.required('Select your date of birth'),
  email: emailSchema.notRequired(),
  first_name: firstNameSchema,
  gender: genderSchema,
  last_name: lastNameShema,
  middle_name: otherNameSchema,
  no_email: yup.boolean().notRequired(),
  phone_number: yup
    .string()
    .required('Phone number is required')
    .transform(value => (typeof value === 'string' ? toInternationalPhone(value) : value))
    .test('e164', 'Enter a valid phone number', value => isValidInternationalPhone(value)),
  ref: yup
    .string()
    .trim()
    .transform(value => (value === '' ? undefined : value))
    .notRequired()
})
